import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  isSupported,
  MessagePayload,
  Messaging,
  onMessage,
  onRegistered,
  register,
} from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyC7r0k-ZHXltmeqKRiaFEgXK6lTeUNeKBI',
  authDomain: 'awake-45e86.firebaseapp.com',
  projectId: 'awake-45e86',
  storageBucket: 'awake-45e86.firebasestorage.app',
  messagingSenderId: '157815016487',
  appId: '1:157815016487:web:8bf522bb4266efc8cc1202',
};

const app = initializeApp(firebaseConfig);
let messaging: Messaging | null = null;

const getMessagingInstance = async () => {
  try {
    if (!(await isSupported())) return null;
    if (!messaging) {
      messaging = getMessaging(app);
      onRegistered(messaging, (installationId) => {
        console.log('Registered installation ID:', installationId);
      });
    }
    return messaging;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const requestPermissionNotification = async () => {
  const instance = await getMessagingInstance();
  if (!instance || typeof Notification === 'undefined') return;

  const permission = await Notification.requestPermission();
  if (permission === 'granted') {
    await register(instance, {
      vapidKey: 'BLoaYFnCIOZJyntMO7NZG53pyPY7Y5hgoU_AmGItoEXwpIDhJfkQMKa-lJMXeGrNuL5FMOOBLUxLNZ5uiq46fL4',
    });
  }
};

export const onMessageListener = (): Promise<MessagePayload | null> =>
  new Promise((resolve) => {
    getMessagingInstance().then((instance) => {
      if (!instance) {
        resolve(null);
        return;
      }
      onMessage(instance, (payload) => {
        resolve(payload);
      });
    });
  });
